export const integrations = [
  {
    name: 'Backend y API',
    status: 'Sin conectar',
    detail: 'Los cambios se guardan solo en este navegador. Conecta una API para persistirlos.',
  },
  {
    name: 'Autenticación',
    status: 'Modo demostración',
    detail: 'Conecta un proveedor (Supabase Auth, Clerk, Auth0) y valida la sesión en el servidor en cada escritura.',
  },
  {
    name: 'Base de datos',
    status: 'Sin conectar',
    detail: 'El catálogo usa datos iniciales locales hasta conectar la base de datos.',
  },
  {
    name: 'Alojamiento de video',
    status: 'Solo enlaces',
    detail: 'Admite enlaces directos MP4 o WebM. La subida de archivos requiere Mux, Cloudflare Stream o Bunny Stream.',
  },
  {
    name: 'Programación de estrenos',
    status: 'Sin verificar',
    detail: 'La fecha se evalúa en el navegador. La publicación automática necesita un proceso en el servidor.',
  },
];
